import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, useIntl } from 'react-intl';

import * as actionsSujet from '../../../actions/sujet';
import * as actionsJourney1 from '../../../actions/journey1';
import * as _actionsBasket from '../../../actions/basket';
import * as _actionsSearch from '../../../actions/search';
import { RootState } from '../../../reducers';
import './DashboardV2.scss';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import { Accordion, AccordionContext, Card, useAccordionButton } from 'react-bootstrap';
import { ReactComponent as CollapseIcon } from '../../../assets/icons/new/chev_down.svg';
import { ReactComponent as ExpandIcon } from '../../../assets/icons/new/chev_up.svg';
import { Button, Input, SwitchSize, SwitchType } from '@repo/apg-ui';
import SpinnerV2 from '../../../components/SpinnerV2';
import Modal from 'react-modal';
import classNames from 'classnames';
import bsStyles from '../../../styles/bs.module.scss';
import { getParameterByName } from '../../../utils/toSearchParams';
import { useNavigate } from 'react-router';
import Legende from '../../../components/Modal/Legende/Legende';
import EditBasketNameModal from '../../../components/Modal/EditBasketName/EditBasketNameModal';
import RemoveBasketModal from '../../../components/Modal/RemoveBasket/RemoveBasket';
import RemoveOfferModal from '../../../components/Modal/RemoveOffer/RemoveOffer';
import CampaignTable from '../../../components/Campaign/CampaignTable';
import { ProductionHelpTextV2 } from './ProductionHelpTextV2';
import { HeaderCards } from './HeaderCards';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  locales: any;
  location: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  journey3: boolean;
  actionsSujet: typeof actionsSujet;
  actionsJourney1: any;
  actionsBasket: typeof _actionsBasket;
  actionsSearch: typeof _actionsSearch;
  history: any;
  validationMessageConfig: any;
  keycloakReady: boolean;
}

export enum Campaigns {
  DEFAULT = 2,
  SHOW_WITHOUT_BTN = 10,
}

export enum CampaignGroupByType {
  STATE = 'state',
  CLIENT = 'client',
}

const ContextAwareToggle = ({ children, eventKey }) => {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey);

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <div
      className='d-flex justify-content-start align-items-center collapse-action cursor-pointer'
      onClick={decoratedOnClick}
    >
      <div className='ps-0'>
        {isCurrentEventKey ? <ExpandIcon className='arrow' /> : <CollapseIcon className='arrow' />}
      </div>
      {children}
    </div>
  );
};

const DashboardV2 = ({
  keycloakReady,
  actionsSujet,
  userDataEC: { userInfo, isAgencyJourney },
  location,
  history,
  actionsBasket,
  actionsSearch,
  journey3,
}: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [campaignsByGroup, setCampaignsByGroup] = React.useState([]);
  const [filteredCampaignsByGroup, setFilteredCampaignsByGroup] = React.useState([]);
  const [groupingByClient, setGroupingByClient] = React.useState<boolean>(false);

  const [isBasketNameEditOpen, setIsBasketNameEditOpen] = React.useState(false);
  const [isBasketRemoveModalOpen, setIsBasketRemoveModalOpen] = React.useState(false);
  const [basketNameEditId, setBasketNameEditId] = React.useState('');
  const [basketNameEditName, setBasketNameEditName] = React.useState('');
  const [basketNameEditReference, setBasketNameEditReference] = React.useState('');

  const [offerRemoveBasketId, setOfferRemoveBasketId] = React.useState('');
  const [basketRemoveReference, setBasketRemoveReference] = React.useState('');
  const [offerRemoveName, setOfferRemoveName] = React.useState('');
  const [offerRemoveCustomer, setOfferRemoveCustomer] = React.useState('');
  const [offerRemoveNumber, setOfferRemoveNumber] = React.useState('');
  const [isOfferRemoveModalOpen, setIsOfferRemoveModalOpen] = React.useState(false);
  const [currentCampaign, setCurrentCampaign] = React.useState(undefined);

  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    if (keycloakReady) {
      fetchCampaigns(groupingByClient ? CampaignGroupByType.CLIENT : CampaignGroupByType.STATE);
    }
  }, []);

  const fetchCampaigns = (groupBy: 'client' | 'state' | 'none' = CampaignGroupByType.STATE) => {
    setLoading(true);

    actionsSujet
      .getCampaigns({
        // @ts-expect-error type mismatch, owner does not exist:
        owner: (window as any).keycloak.tokenParsed['gepard-nr'],
        groupby: groupBy,
      })
      .then((_campaignsByGroup) => {
        if (_campaignsByGroup) {
          const campaigns = _campaignsByGroup
            .sort((a, b) => parseInt(a.groupvalue) - parseInt(b.groupvalue))
            .map((group) => {
              group.showExpired = groupBy === CampaignGroupByType.CLIENT;
              return group;
            });
          setCampaignsByGroup([...campaigns]);
          setFilteredCampaignsByGroup([...campaigns]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setExpiredCampaignVisibility = (value, groupIndex): void => {
    let campaigns = JSON.parse(JSON.stringify(campaignsByGroup));

    if (campaigns && campaigns[groupIndex]) {
      campaigns[groupIndex].showExpired = value;

      if (!value) {
        campaigns[groupIndex].list = campaigns[groupIndex].list.filter(
          (campaign: { stategroup: number }) => campaign?.stategroup != 4 && campaign?.stategroup != 5,
        );
      }
      setFilteredCampaignsByGroup([...campaigns]);
    }
  };

  const renderModalContent = (modalContent) => {
    if (modalContent === 'legende') {
      return <Legende />;
    } else if (modalContent === 'basketEdit') {
      return (
        <EditBasketNameModal
          onClose={() => {
            setIsBasketNameEditOpen(false);
          }}
          onSuccess={updateBasketName}
          initName={basketNameEditName}
          basketId={basketNameEditId}
          basketreference={basketNameEditReference}
          updateBasketName={actionsBasket.postBasketData}
        />
      );
    } else if (modalContent === 'removeOffer') {
      return (
        <RemoveOfferModal
          basketId={offerRemoveBasketId}
          name={offerRemoveName}
          customer={offerRemoveCustomer}
          offerId={offerRemoveNumber}
          onClose={() => {
            setIsOfferRemoveModalOpen(false);
          }}
          onSuccess={() => {
            setIsOfferRemoveModalOpen(false);
          }}
          removeBasket={removeCampaign}
        />
      );
    } else if (modalContent === 'removeBasket') {
      return (
        <RemoveBasketModal
          basketId={offerRemoveBasketId}
          basketreference={basketRemoveReference}
          initName={offerRemoveName}
          onClose={() => {
            setIsBasketRemoveModalOpen(false);
          }}
          onSuccess={() => {
            setIsBasketRemoveModalOpen(false);
          }}
          removeBasket={removeCampaign}
        />
      );
    }
  };

  const modalContent = getParameterByName('modalContent', location.search);

  const removeCampaign = (basketId: string) => {
    return actionsBasket.deleteBasket({ basket: Number(basketId) }).then(() => {
      const updateGroups = (groups) =>
        groups.map((group) => {
          if (group.groupvalue === currentCampaign?.groupvalue) {
            group.list = group.list.filter((campaign) => campaign.basket.id !== basketId);
          }
          return group;
        });

      setCampaignsByGroup(updateGroups([...campaignsByGroup]));
      setFilteredCampaignsByGroup(updateGroups([...filteredCampaignsByGroup]));
      setCurrentCampaign(undefined);
    });
  };

  const updateBasketName = (basketId: string, basketreference: string, name: string) => {
    const updateGroups = (groups) =>
      groups.map((group) => {
        if (group.groupvalue === currentCampaign?.groupvalue) {
          group.list = group.list.map((campaign) => {
            if (campaign.basket.id === basketId && campaign.basket.basketreference === basketreference) {
              campaign.basket.name = name;
              campaign.name = name;
            }
            return campaign;
          });
        }
        return group;
      });

    setCampaignsByGroup(updateGroups([...campaignsByGroup]));
    setFilteredCampaignsByGroup(updateGroups([...filteredCampaignsByGroup]));
    setCurrentCampaign(undefined);
  };

  const refreshCampaignData = (newCampaign, groupvalue) => {
    if (groupingByClient) {
      const updateGroups = (groups) =>
        groups.map((group) => {
          if (group.groupvalue.toString() === groupvalue.toString()) {
            group.list = group.list.map((campaign) => {
              if (campaign.number.toString() === newCampaign.number.toString()) {
                return newCampaign;
              }
              return campaign;
            });
          }
          return group;
        });

      setCampaignsByGroup(updateGroups([...campaignsByGroup]));
      setFilteredCampaignsByGroup(updateGroups([...filteredCampaignsByGroup]));
    } else {
      const updateGroups = (groups) =>
        groups.map((group) => {
          if (group.groupvalue.toString() === groupvalue.toString()) {
            group.list = group.list.filter((campaign) => campaign.number.toString() !== newCampaign.number.toString());
          }
          if (group.groupvalue.toString() === newCampaign.stategroup.toString()) {
            group.list.unshift(newCampaign);
          }
          return group;
        });

      setCampaignsByGroup(updateGroups([...campaignsByGroup]));
      setFilteredCampaignsByGroup(updateGroups([...filteredCampaignsByGroup]));
    }
  };

  return (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={intl.formatMessage({ id: 'ec.navigation.dashboard', defaultMessage: 'Dashboard' })}
        secondLevelLabel={intl.formatMessage({ id: 'ec.navigation.dashboard', defaultMessage: 'Dashboard' })}
      />
      <div
        className={classNames('container-fluid journey1 overflow-hidden p-0', {
          journey3: journey3,
        })}
      >
        {modalContent && (
          <Modal
            isOpen={Boolean(modalContent)}
            onRequestClose={() => {
              navigate({ search: '' });
              // this.setState({ isModalOpen: false, modalContent: null });
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal', bsStyles.bootstrap)}>{renderModalContent(modalContent)}</div>
          </Modal>
        )}

        {isBasketNameEditOpen && (
          <Modal
            isOpen={isBasketNameEditOpen}
            onRequestClose={() => {
              setIsBasketNameEditOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal small-modal', bsStyles.bootstrap)}>
              {renderModalContent('basketEdit')}
            </div>
          </Modal>
        )}

        {isBasketRemoveModalOpen && (
          <Modal
            isOpen={isBasketRemoveModalOpen}
            onRequestClose={() => {
              setIsBasketRemoveModalOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal small-modal', bsStyles.bootstrap)}>
              {renderModalContent('removeBasket')}
            </div>
          </Modal>
        )}
        {isOfferRemoveModalOpen && (
          <Modal
            isOpen={isOfferRemoveModalOpen}
            onRequestClose={() => {
              setIsOfferRemoveModalOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div className={classNames('modal small-modal', bsStyles.bootstrap)}>
              {renderModalContent('removeOffer')}
            </div>
          </Modal>
        )}

        <div className='pageContainer dashboard-cards'>
          <HeaderCards userInfo={userInfo} isAgency={isAgencyJourney} isUserInfoLoading={userInfo === null} />
        </div>

        <ErrorContainer journeyType='dashboard' />

        {!isAgencyJourney && (
          <div className='pageContainerTwo py-0 pb-5'>
            <ProductionHelpTextV2 />
          </div>
        )}

        <div className={classNames('pageContainerTwo mb-3 pb-0', { 'pt-3': isAgencyJourney })}>
          <div className='page-header'>
            <div className='page-actions'>
              {isAgencyJourney && (
                <div className='d-flex align-items-center justify-content-start'>
                  <Input
                    name={'agencyPanelToggleInput'}
                    type='switch'
                    disabled={loading}
                    switchType={SwitchType.ROUNDED}
                    size={SwitchSize.MIDDLE}
                    inputWrapperClass={'m-0 me-3'}
                    defaultChecked={groupingByClient}
                    value={groupingByClient}
                    onChange={(name, value) => {
                      setGroupingByClient(value);
                      fetchCampaigns(value ? CampaignGroupByType.CLIENT : CampaignGroupByType.STATE);
                    }}
                  />

                  <div className='d-flex flex-column font-16 font-600 lh-sm'>
                    <span>
                      <FormattedMessage id='ec.dashboard.groupingByClient' defaultMessage='Nach Kunden gruppieren' />
                    </span>
                  </div>
                </div>
              )}
              {!journey3 && !isAgencyJourney && (
                <Button className='mt-24' onClick={() => navigate({ search: `?modalContent=legende` })}>
                  <div className='legend d-flex'>
                    <p className='red-text'>
                      <FormattedMessage id='ec.confirmation.legend' defaultMessage='Legende' />
                    </p>
                  </div>
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className='pageContainerTwo pt-0'>
          <div className='product-result-wrapper'>
            <div className='products-result-collapsible-group'>
              {!loading && filteredCampaignsByGroup && filteredCampaignsByGroup.length
                ? filteredCampaignsByGroup.map(({ list, groupvalue, grouplabel, showExpired }, index) => {
                    return (
                      <Accordion defaultActiveKey='1' key={index} className={'campaign-table-wrapper'}>
                        <Card>
                          <ContextAwareToggle eventKey={groupvalue}>
                            <Card.Header>
                              <div className='d-flex flex-column flex-md-row justify-content-between align-items-center w-100'>
                                <div className='d-flex align-items-center gap-4'>
                                  <span className='table-header'>
                                    {grouplabel} ({list.length})
                                  </span>
                                </div>
                                {isAgencyJourney && groupingByClient && (
                                  <div className='d-flex align-items-center justify-content-start'>
                                    <Input
                                      name={'showExpiredCampaignSwitch' + index}
                                      type='switch'
                                      switchType={SwitchType.ROUNDED}
                                      size={SwitchSize.MIDDLE}
                                      inputWrapperClass={'m-0 me-3'}
                                      defaultChecked={showExpired}
                                      value={showExpired}
                                      onChange={(name, value) => {
                                        setExpiredCampaignVisibility(value, index);
                                      }}
                                    />

                                    <div className='d-flex flex-column font-16 font-600 lh-sm'>
                                      <span>
                                        <FormattedMessage
                                          id='ec.dashboard.showExpiredCampaigns'
                                          defaultMessage='Abgelaufene Kampagnen anzeigen'
                                        />
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Card.Header>
                          </ContextAwareToggle>
                          <Accordion.Collapse eventKey={groupvalue}>
                            <Card.Body>
                              <CampaignTable
                                key={`CampaignTable-${groupvalue}`}
                                campaigns={list}
                                isAgencyJourney={isAgencyJourney}
                                showExpired={showExpired}
                                groupingByClient={groupingByClient}
                                onRemove={(campaign) => {
                                  setCurrentCampaign({
                                    campaign: campaign,
                                    groupvalue: groupvalue,
                                  });
                                  const { basket, customer, number } = campaign;
                                  setOfferRemoveBasketId(basket.id);
                                  setOfferRemoveName(basket.name);
                                  setOfferRemoveCustomer(customer);
                                  setOfferRemoveNumber(number);
                                  setBasketRemoveReference(basket.basketreference);
                                  setIsBasketRemoveModalOpen(groupvalue == 3);
                                  setIsOfferRemoveModalOpen(groupvalue == 2);
                                }}
                                onBasketUnlock={(campaign) => {
                                  refreshCampaignData(campaign, groupvalue);
                                }}
                                openEditBasketModal={(campaign) => {
                                  setCurrentCampaign({
                                    campaign: campaign,
                                    groupvalue: groupvalue,
                                  });
                                  const { basket } = campaign;
                                  setBasketNameEditId(basket.id);
                                  setBasketNameEditReference(basket.basketreference);
                                  setBasketNameEditName(basket.name);
                                  setIsBasketNameEditOpen(true);
                                }}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                    );
                  })
                : !filteredCampaignsByGroup.length && !loading
                  ? 'No campaign available'
                  : null}

              {loading && <SpinnerV2 relative />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
    actionsJourney1: bindActionCreators(actionsJourney1 as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardV2));
